import { differenceInMinutes } from 'date-fns';
import React from 'react';
import { Tag } from './Tag';

/** Orange when ≤ this many hours remain before the SLA deadline. Works for any SLA window size. */
const ORANGE_THRESHOLD_HOURS_REMAINING = 4;

function formatDurationDisplay(
  totalMinutes: number,
  suffix: ' left' | ' ago',
): string {
  const safeMinutes = Math.max(0, Math.floor(totalMinutes));
  if (safeMinutes < 60) {
    return `${safeMinutes}m${suffix}`;
  }
  const totalHours = Math.floor(safeMinutes / 60);
  if (totalHours >= 24) {
    const days = Math.floor(totalHours / 24);
    const remainingHours = totalHours % 24;
    return `${days}d ${remainingHours}h${suffix}`;
  }
  return `${totalHours}h${suffix}`;
}

export function SlaCountdown({ sla }: { sla: string | null }) {
  if (!sla || typeof sla !== 'string') {
    return <span>-</span>;
  }

  const now = new Date();
  const deadline = new Date(sla);
  if (Number.isNaN(deadline.getTime())) {
    return <span>-</span>;
  }
  const isPast = now >= deadline;
  const minutesRemaining = Math.max(0, differenceInMinutes(deadline, now));
  const minutesPastDeadline = Math.max(0, differenceInMinutes(now, deadline));

  const tagColor = isPast
    ? 'Red'
    : minutesRemaining / 60 <= ORANGE_THRESHOLD_HOURS_REMAINING
      ? 'Orange'
      : 'Green';

  const displayText = isPast
    ? formatDurationDisplay(minutesPastDeadline, ' ago')
    : formatDurationDisplay(minutesRemaining, ' left');

  return <Tag color={tagColor}>{displayText}</Tag>;
}
